abstract class LangStorage {
    static set(lang: string) {
        localStorage.setItem('lang', lang);
    }
    static get(): string | null {
        return localStorage.getItem('lang');
    }
}

export default LangStorage